import { useContext } from 'react';

import { SessionContext, type SessionValue } from './session-context';

/** The signed-in administrator. Throws outside the provider rather than guessing. */
export function useSession(): SessionValue {
  const value = useContext(SessionContext);
  if (!value) throw new Error('useSession must be used inside a SessionProvider');
  return value;
}
